<template>
    <div class="kvSwiper" >
        <swiper class="swiper" :options="swiperOption">
            <template v-for="(item, index) in kvTrueList">
                <swiper-slide :key="index" @click="clickSwiperItem(item)">
                    <img class="img" :src="item.url" v-if="isImage(item)" />
                    <video class="video" v-if="isMp4(item)" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline x-webkit-airplay='allow' :src="item.url" muted="muted" autoplay="autoplay" loop="loop" preload="auto"></video>
                    <div class="wapKv" :id="'wapKv'+index " v-if="isAnim(item)"></div>
                </swiper-slide>
            </template>
            <div class="swiper-pagination" slot="pagination" v-if="kvTrueList.length > 1"></div>
        </swiper>

    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { isMobile } from '../utils/index';
export default {
    components: {
        Swiper,
        SwiperSlide
    },
    props: {
        kvList: {
            type: Array,
            default: []
        },
        canvasWidth: {
            type: Number,
            default: 0,
        },
        canvasHeight: {
            type: Number,
            default: 0,
        },
        speed: {
            type: Number,
            default: 40,
        },
    },
    data() {
        return {
            isMobile: isMobile(),
            isImage: function (item) {
                if (item.type == 'video_image') {
                    if (item.url.indexOf('.mp4') >= 0) {
                        return false;
                    } else {
                        return true;
                    }
                }
                return false;
            },
            isMp4: function (item) {
                if (item.type == 'video_image') {
                    if (item.url.indexOf('.mp4') >= 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return false;
            },
            isAnim: function (item) {
                if (item.type == 'animation') {
                    return true;
                }
                return false;
            },
            swiperOption: {
                spaceBetween: 0,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
            },
            kvTrueList: [],
            canvasImageObjectList: [],
        };
    },
    created() {
        var trueList = [];
        if (this.isMobile) {
            for (var k in this.kvList) {
                this.kvList[k].wap['target'] = this.kvList[k].target;
                trueList.push(this.kvList[k].wap);
            }
        } else {
            for (var k in this.kvList) {
                this.kvList[k].pc['target'] = this.kvList[k].target;
                trueList.push(this.kvList[k].pc);
            }
        }
        this.kvTrueList = trueList;
        if (this.kvTrueList.length > 1) {
            // this.swiperOption.loop = true;
        }
    },
    mounted() {
        if (this.isMobile) {
            this.initKvImages();
        }
    },
    beforeDestroy() {
        for (var k in this.canvasImageObjectList) {
            this.canvasImageObjectList[k].stop();
        }
    },
    methods: {
        initKvImages() {
            var that = this;
            for (var k in this.kvTrueList) {
                if (this.kvTrueList[k].type == 'animation') {
                    var kvItem = this.kvTrueList[k];
                    var kvImages = [];
                    for (var i = kvItem.animationMin; i <= kvItem.animationMax; i++) {
                        kvImages.push(kvItem.animationUrl + i + kvItem.animationExt);
                    }
                    var canvasImageObject = new CanvasAnimation({
                        id: 'wapKv' + k,
                        canvasWidth: this.canvasWidth,
                        canvasHeight: this.canvasHeight,
                        speed: this.speed,
                        imagePlayType: CanvasAnimationImagePlayType.LoadingAndPlay,
                        showLoading: false,
                        autoPlay: true,
                        showLoading: true,
                    });
                    canvasImageObject.setDefaultImage(kvImages[0]);
                    canvasImageObject.setImagesUrls(kvImages);
                    canvasImageObject.init();
                    canvasImageObject.on('loadedNextImageFirst', function (animObject) {
                        console.log('loadedNextImageFirst')
                        animObject.play();
                    });
                    this.canvasImageObjectList.push(canvasImageObject);
                }
            }
        },
        clickSwiperItem(item) {
            console.log(item);
            if (item.target) {
                window.location.href = item.target;
            }
        }
    },
};
</script>
<style  >
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    background-color: #fff;
    opacity: 1;
}

.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet-active {
    background-color: #fff;
    width: 20px;
    border-radius: 4px;
}
@media screen and (max-width: 750px) {
    .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{
        margin-bottom: -6px;
    }
}
</style>
<style scoped lang="scss" >
.kvSwiper {
    width: 100%;
    height: 100%;
    position: relative;

    * {
        transform: translate3d(0, 0, 0);
    }

    // .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
    //     width: 10px;
    //     height: 8px;
    //     background-color: #fff;
    //     border-radius: 4px;
    // }


    .swiper {
        width: 100%;
        height: 100%;

        .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            background-color: #000;
        }
    }

    .wapKv {
        width: 100%;
        height: 100%;
    }
}
</style>
